import { Injectable } from '@angular/core';
// import { EmailComposer } from '@ionic-native/email-composer/ngx';

export class Email {
  to: string;
  subject: string;
  body: string;
}

@Injectable()
export class EmailService {
  constructor() // private emailComposer: EmailComposer
  {}

  sendEmail(email: Email) {
    // return this.emailComposer.open(email);
    return false;
  }
}
